import { render, staticRenderFns } from "./HotlineRegister.vue?vue&type=template&id=7ff3db95&scoped=true&"
import script from "./HotlineRegister.vue?vue&type=script&lang=js&"
export * from "./HotlineRegister.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/hotline.css?vue&type=style&index=0&id=7ff3db95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3db95",
  null
  
)

export default component.exports